import RestauranteAuditoriaService from "@/services/RestauranteAuditoriaService";

export const restauranteAuditoria = {
  namespaced: true,
  state: {
    restauranteAuditoria: {},
  },
  actions: {
    getRestauranteAuditoria({ commit }, payload) {
      return RestauranteAuditoriaService.GetRestauranteAuditoria(payload).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRestauranteAuditoria({ commit }, payload) {
      return RestauranteAuditoriaService.PostRestauranteAuditoria(payload).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putRestauranteAuditoria({ commit }, payload) {
      return RestauranteAuditoriaService.PutRestauranteAuditoria(payload).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteRestauranteAuditoria({ commit }, payload) {
      return RestauranteAuditoriaService.DeleteRestauranteAuditoria(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRestauranteAuditoriaOData({ commit }, payload) {
      return RestauranteAuditoriaService.GetRestauranteAuditoriaOData(
        payload
      ).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getRestauranteAuditoriaPesquisa({ commit }, payload) {
      return RestauranteAuditoriaService.GetRestauranteAuditoriaPesquisa(
        payload
      ).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postRegistrarRestauranteAuditoria({ commit }, payload) {
      return RestauranteAuditoriaService.PostRegistrarRestauranteAuditoria(
        payload
      ).then(
        (restauranteAuditoria) => {
          return Promise.resolve(restauranteAuditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default restauranteAuditoria;
